import { BRAND_LIST_ACTION } from "core/constants/Actions";
import { TypedThunk, TypedDispatch } from "App/Store";
import { getBrands } from "core/services/Brand";

export function getBrandList(params?: any): TypedThunk {
  return async (dispatch: TypedDispatch) => {
    dispatch({ type: BRAND_LIST_ACTION.REQUEST });
    const apiResponse = await getBrands(params);
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: BRAND_LIST_ACTION.SUCCESS,
        payload: {
          brands: apiResponse.data.brands,
          count: apiResponse.data.count,
        },
      });
    } else {
      dispatch({ type: BRAND_LIST_ACTION.FAILURE });
    }
  };
}
